module.exports = __webpack_public_path__ + "static/img/case-img05.3853ec2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/4.0.2/case-img05.png
// module id = FWIU
// module chunks = 43